import React, { useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import type { ApiResponse } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/types";

import { EmptyWarningMessage, InvalidEmailMessage, SubmitErrorMessage } from "./consts";
import { checkIsValidEmail } from "./helpers";
import {
  Container,
  EmailInput,
  Form,
  IconContainer,
  InputContainer,
  StyledIconArrowPrevious,
  StyledSignupButton,
  WarningMessage,
} from "./styles";
import type { FormSubmitValue } from "./types";

export type Props = {
  onPreviousClick: () => void;
  onSubmit: (form: FormSubmitValue) => Promise<ApiResponse>;
};

export const EmailForm: React.FunctionComponent<Props> = ({
  onPreviousClick,
  onSubmit,
  ...props
}) => {
  const [emailInput, setEmailInput] = useState("");
  const [warningMessage, setWarningMessage] = useState(EmptyWarningMessage);
  const [isLoading, setIsLoading] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleOnSubmit = async () => {
    if (!checkIsValidEmail(emailInput)) {
      setWarningMessage(InvalidEmailMessage);
      return;
    }
    setIsLoading(true);
    const recaptchaToken = await executeRecaptcha?.();
    if (!recaptchaToken) return;
    setWarningMessage(EmptyWarningMessage);
    const apiResponse = await onSubmit({
      email: emailInput,
      recaptchaToken,
    });
    if (apiResponse?.error) {
      setWarningMessage(SubmitErrorMessage);
      setIsLoading(false);
    }
  };

  return (
    <Container {...props}>
      <IconContainer>
        <StyledIconArrowPrevious height="15" onClick={onPreviousClick} width="15" />
      </IconContainer>
      <Form
        method="post"
        onSubmit={event => {
          event.preventDefault();
          void handleOnSubmit();
        }}
      >
        <InputContainer>
          <EmailInput
            $isError={!!warningMessage}
            onChange={event => {
              if (!event.target.value) {
                setWarningMessage(EmptyWarningMessage);
              }
              setEmailInput(event.target.value);
            }}
            placeholder="Email"
            value={emailInput}
          />
          {warningMessage && <WarningMessage>{warningMessage}</WarningMessage>}
        </InputContainer>
        <StyledSignupButton
          isLoading={isLoading}
          onClick={event => {
            event.preventDefault();
            void handleOnSubmit();
          }}
        >
          SIGN UP
        </StyledSignupButton>
      </Form>
    </Container>
  );
};

EmailForm.displayName = "EmailForm";
